/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/naming-convention */
import React, { createContext, useCallback } from 'react'
import PhoneComUser from 'phone-com-user'
import ajax from 'ajax'
import { getPhoneCom } from 'phonecom'
import PropTypes from 'prop-types'
import { useEnrollmentContext } from '../hooks/useEnrollmentContext'
import { EnrollmentType } from '../interface/EnrollmentType'
import { useAjax } from '../hooks/useAjax'

interface SmsNumberCampaignContextInterface {
    campaignsWithNumber: any[],
    loadingSmsNumberCampaignContext: boolean,
    numberNetworkError: any,
    networkPending: boolean,
    eligibleNumbers: any[],
    fetchEligibleNumbersStatus: 'idle' | 'pending' | 'success' | 'error',
    initialFetching: boolean,

    deleteNumber: (params) => void,
    addNumber: (params) => void,
    setNumberNetworkError: (error) => void,
    fetchEligibleNumbers: (campaignId) => Promise<any>
}

/**
 *
 */
export const SmsNumberCampaignContext = createContext<SmsNumberCampaignContextInterface>({
    campaignsWithNumber: [],
    loadingSmsNumberCampaignContext: false,
    numberNetworkError: null,
    networkPending: false,
    eligibleNumbers: [],
    fetchEligibleNumbersStatus: 'idle',
    initialFetching: false,

    deleteNumber: (params) => { },
    addNumber: (params) => { },
    setNumberNetworkError: () => { },
    fetchEligibleNumbers: async () => { }
})

/**
 * @param {object} root0
 * @param {object} root0.children
 */
export const SmsNumberCampaignContextProvider = ({ children }) => {
    const fetchCampaignsWithNumberUrl = `${PhoneComUser.getv5ApiRoot()}/messages/10dlc/list-phone-numbers`
    const enrollCampaignDidUrl = `${PhoneComUser.getv5ApiRoot()}/messages/10dlc/enroll-campaign-did`

    const getFetchParams = async () => {
        const phonecom = await getPhoneCom()
        const params = { account_id: phonecom.voip_id }
        return params
    }

    const {
        enrollments: campaignsWithNumber,
        deleteEnrollment: deleteNumber,
        addEnrollment: addNumber,
        enrollmentNetworkError: numberNetworkError,
        setEnrollmentNetworkError: setNumberNetworkError,
        crudNetworkPending,
        isFetchingEnrollments: loadingSmsNumberCampaignContext,
        initialFetching
    } = useEnrollmentContext({
        enrollmentFetchUrl: fetchCampaignsWithNumberUrl,
        enrollmentAddUrl: enrollCampaignDidUrl,
        enrollmentDeleteUrl: enrollCampaignDidUrl,
        enrollmentEditUrl: '',
        enrollmentPaymentDetailsUrl: '',
        enrollmentType: EnrollmentType.SmsNumber,
        verifiedEnrollmenPredicate: () => {
            return false
        },
        initialFetchParams: getFetchParams()
    })

    const executeFetchEligibleNumbers = useCallback(async (campaignId) => {
        const phonecom = await getPhoneCom()
        const params = {
            account_id: phonecom.voip_id,
            campaign_id: null
        }

        return ajax.post(fetchCampaignsWithNumberUrl, params, 'Bearer')
            .then((rv) => {
                return new Promise((resolve, reject) => {
                    if (rv?.status === 200) {
                        resolve(rv.data)
                    } else {
                        const err = rv.message || rv
                        reject(err)
                    }
                })
            })
    }, [fetchCampaignsWithNumberUrl])
    const { execute: fetchEligibleNumbers, value: eligibleNumbers, status: fetchEligibleNumbersStatus } = useAjax(executeFetchEligibleNumbers, false) as any

    return (
        <SmsNumberCampaignContext.Provider value={{
            campaignsWithNumber,
            loadingSmsNumberCampaignContext,
            networkPending: crudNetworkPending,
            numberNetworkError,
            fetchEligibleNumbers,
            eligibleNumbers,
            fetchEligibleNumbersStatus,
            deleteNumber,
            addNumber,
            setNumberNetworkError,
            initialFetching
        }}>
            {children}
        </SmsNumberCampaignContext.Provider>
    )
}

SmsNumberCampaignContextProvider.propTypes = {
    children: PropTypes.any
}
